import axios from 'axios'

const API_URL = import.meta.env.VITE_API_URL || 'http://localhost:3001'

const api = axios.create({
  baseURL: `${API_URL}/api`,
  headers: {
    'Content-Type': 'application/json'
  }
})

// Add token to requests
api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token')
  if (token) {
    config.headers.Authorization = `Bearer ${token}`
  }
  return config
})

// Auth APIs
export const authAPI = {
  signup: (username: string, email: string, password: string) =>
    api.post('/auth/signup', { username, email, password }),

  login: (username: string, password: string) =>
    api.post('/auth/login', { username, password }),

  getProfile: () => api.get('/auth/profile')
}

// Card APIs
export const cardAPI = {
  getAllCards: () => api.get('/cards'),

  getUserCards: () => api.get('/cards/my-cards'),

  drawCard: () => api.post('/cards/draw', {}),

  getAttributeAdvantages: () => api.get('/cards/attribute-advantages'),

  getTeams: () => api.get('/teams'),

  createTeam: (name: string, card_slots: number[]) =>
    api.post('/teams', { name, card_slots }),

  updateTeam: (teamId: number, data: any) =>
    api.put(`/teams/${teamId}`, data),

  deleteTeam: (teamId: number) =>
    api.delete(`/teams/${teamId}`)
}

// Battle APIs
export const battleAPI = {
  startBattle: (teamId: number, isPvP: boolean = false, opponentId?: number) =>
    api.post('/battles/start', { teamId, isPvP, opponentId }),

  executeRound: (battleState: any, playerAttackIndex: number, playerDefenseIndex: number, opponentAttackIndex: number, opponentDefenseIndex: number) =>
    api.post('/battles/round', { battleState, playerAttackIndex, playerDefenseIndex, opponentAttackIndex, opponentDefenseIndex }),

  finishBattle: (opponentId: number | null, winner: string, battleLog: any[], rewards: any) =>
    api.post('/battles/finish', { opponentId, winner, battleLog, rewards }),

  getBattleHistory: (limit: number = 20) =>
    api.get(`/battles/history?limit=${limit}`),

  getDailyDraws: () =>
    api.get('/battles/daily-draws')
}

// Admin APIs
export const adminAPI = {
  login: (password: string) =>
    api.post('/admin/login', { password }),

  getAllUsers: () =>
    api.get('/admin/users'),

  getUserData: (userId: number) =>
    api.get(`/admin/users/${userId}`),

  modifyUserData: (userId: number, data: any) =>
    api.put(`/admin/users/${userId}`, data),

  createAnnouncement: (title: string, content: string, expiresAt?: string) =>
    api.post('/admin/announcements', { title, content, expiresAt }),

  getAnnouncements: () =>
    api.get('/admin/announcements'),

  deleteAnnouncement: (announcementId: number) =>
    api.delete(`/admin/announcements/${announcementId}`),

  getGameStats: () =>
    api.get('/admin/stats')
}

export default api
